import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const GitHubCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && window.opener) {
      // Send the code back to the parent window
      window.opener.postMessage({
        type: 'github-oauth-success',
        code,
        state
      }, window.location.origin);
      
      // Close this popup
      window.close();
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Loader2 className="h-12 w-12 animate-spin text-orange-500 mb-4" />
      <p className="text-gray-600">Completing GitHub connection...</p>
    </div>
  );
};

export default GitHubCallback;
